var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 261.61,
    height: 261.61,
    viewBox: "0 0 261.61 261.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.925,
    y1: 0.925,
    x2: 0.075,
    y2: 0.075,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9987ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f04e98"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_61",
    x: 0,
    y: 0,
    width: 261.61,
    height: 261.61,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.11,
    dy: 6.11,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.182,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Care",
    transform: "translate(-833.575 -5344.617)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 833.58, 5344.62)",
    filter: "url(#Rectangle_61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61-2",
    "data-name": "Rectangle 61",
    width: 248.517,
    height: 248.517,
    rx: 63.606,
    transform: "translate(0.44 0.44)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "favourite_premium",
    "data-name": "favourite premium"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M997.143,5432.059l-35.226,37.654a4.937,4.937,0,0,1-3.6,1.565c-1.172,3.324-37.8-38.826-38.917-39.223a23.138,23.138,0,0,1,.005-31.19c12.479-12.506,26.924-5.845,36.232,6.526,3.948,4.355,8.842-4.554,11.392-6.526C987.687,5380.107,1015.97,5411.766,997.143,5432.059Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M907.226,5495.8c-.9-.092-1.459-.367-.08-1.183Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M907.226,5495.8c-.9-.092-1.459-.367-.08-1.183Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M928.955,5504.814a.285.285,0,0,0,.04.119C929.1,5505.013,929.075,5504.953,928.955,5504.814Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M902.375,5544.384c-6.776-.922-25.38,3.844-25.209-7.771v-43.607a7.771,7.771,0,0,1,7.771-7.771c6.775.922,25.379-3.845,25.208,7.77v43.608A7.771,7.771,0,0,1,902.375,5544.384Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M1039.375,5506.455a9.3,9.3,0,0,1-5.422,8.357c-2.779,1.392-21.917,10.272-24.08,11.581-7.294,3.83-14.668,7.488-21.895,11.441-19.586,1.8-39.822.234-59.614.77-4.263-.268-14.737,1.73-14.586-6v-30.789a6.029,6.029,0,0,1,6.01-6.011c11.156-.09,50.435.139,62.289.04,9.933-.45,14.025,12.973,5.172,17.432,5.514,2.314,32.691-13.331,37.849-15.135C1031.314,5495.036,1039.483,5499.487,1039.375,5506.455Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M928.995,5504.933a.285.285,0,0,1-.04-.119C929.075,5504.953,929.1,5505.013,928.995,5504.933Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M928.955,5504.814c.12.139.15.2.04.119A.285.285,0,0,1,928.955,5504.814Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M947.964,5498.544c-1.372-.027-2.792.082-4.153-.04C943.919,5498.516,948,5498.47,947.964,5498.544Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare);
export default __webpack_public_path__ + "static/media/Care.27c1d4f692fdec8cb271a6074ed8d3a0.svg";
export { ForwardRef as ReactComponent };